import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Grad, ApiClientService } from '../../services/api-client.service';
import { CacheService } from '../../services/cache.service';

@Component({
  selector: 'app-gradovi',
  templateUrl: './gradovi.component.html',
  styleUrls: ['./gradovi.component.scss']
})
export class GradoviComponent {
  @ViewChild('gradoviGrid', { static: false }) gradoviGrid: any;

  gridData: Grad[] = [];
  loading = false;
  isEditPopupVisible = false;
  isCreatePopupVisible = false;
  selectedGrad: Grad | null = null;
  loadPanelPosition = { of: '#gradoviGrid' };

  gradForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder,
    private cache: CacheService
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadGradovi();
  }

  initializeForm() {
    this.gradForm = this.fb.group({
      grad1: ['', Validators.required],
      broj_poste: ['', [Validators.required, Validators.min(1)]]
    });
  }

  async loadGradovi(invalidateCache: boolean = false) {
    this.loading = true;
    try {
      if (invalidateCache) {
        this.cache.remove('gradovi');
      }
      this.gridData = await this.cache.getCachedOrFetch('gradovi', () => this.apiClient.gradoviAll());
    } catch (error) {
      console.error('Error loading gradovi:', error);
    } finally {
      this.loading = false;
    }
  }

  onGradRowClick(e: any) {
    if (e.data) {
      this.selectedGrad = e.data;
    }
  }

  onAddClick() {
    this.selectedGrad = null;
    this.gradForm.reset();
    this.isCreatePopupVisible = true;
  }

  onEditClick() {
    if (this.selectedGrad) {
      this.populateForm(this.selectedGrad);
      this.isEditPopupVisible = true;
    }
  }

  onDeleteClick() {
    if (this.selectedGrad && confirm('Da li ste sigurni da želite obrisati ovaj grad?')) {
      this.deleteGrad(this.selectedGrad.id as number);
    }
  }

  populateForm(grad: Grad) {
    this.gradForm.patchValue({
      grad1: grad.grad1,
      broj_poste: grad.broj_poste
    });
  }

  async createGrad() {
    if (this.gradForm.valid) {
      this.loading = true;
      try {
        const formData = this.gradForm.value;
        delete formData.id;
        await this.apiClient.gradoviPOST(formData);
        this.isCreatePopupVisible = false;
        this.gradForm.reset();
        this.loadGradovi(true); // Refresh grid
      } catch (error) {
        console.error('Error creating grad:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async updateGrad() {
    if (this.gradForm.valid && this.selectedGrad) {
      this.loading = true;
      try {
        const formData = this.gradForm.value;
        formData.id = this.selectedGrad.id;
        await this.apiClient.gradoviPUT(this.selectedGrad.id as number, formData);
        this.isEditPopupVisible = false;
        this.loadGradovi(true); // Refresh grid
      } catch (error) {
        console.error('Error updating grad:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  async deleteGrad(id: number) {
    this.loading = true;
    try {
      await this.apiClient.gradoviDELETE(id);
      this.selectedGrad = null;
      this.loadGradovi(true); // Refresh grid
    } catch (error) {
      console.error('Error deleting grad:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadGradovi();
  }

  onEditPopupHidden() {
    this.isEditPopupVisible = false;
    this.selectedGrad = null;
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
